import { createContext } from 'react';
import { components } from '@api/club/generated';

import { FUNC_NOOP } from '@libs/constants';

type RcfUserSearchContext = {
  query: string;
  setQuery: (query: string) => void;
  rcfUsers: components['schemas']['RcfRatingDto'][];
  isLoading: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
};

export const RcfUserSearchContext = createContext<RcfUserSearchContext>({
  query: '',
  setQuery: FUNC_NOOP,
  rcfUsers: [],
  isLoading: false,
  hasNextPage: false,
  fetchNextPage: FUNC_NOOP,
});
